import '../css/app.css';
import './bootstrap';
import { startAppHeightSync } from './utils/app-height';
import { startInertiaHttpExceptionHandler } from './utils/inertiaHttpException';

startAppHeightSync();

import { createInertiaApp, router } from '@inertiajs/vue3';

startInertiaHttpExceptionHandler(router);
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { cloneDeep } from 'lodash';
import { createSSRApp, DefineComponent, h } from 'vue';
import VueAwesomePaginate from 'vue-awesome-paginate';
import 'vue-awesome-paginate/dist/style.css';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/src/js';

import { createPinia } from 'pinia';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import 'tippy.js/dist/tippy.css';
import VueTippy from 'vue-tippy';
import TooltipConfig from './Directives/config/TooltipConfig';

// Setup debug logger globally
const setupDebugLogger = () => {
  const isProduction = import.meta.env.VITE_APP_ENV === 'production';
  const urlParams = new URLSearchParams(window.location.search);
  const debugMode = urlParams.get('debug') === 'true';

  if (isProduction && !debugMode) {
    const originalLog = console.log;
    const originalWarn = console.warn;
    const originalError = console.error;
    const originalInfo = console.info;
    const originalDebug = console.debug;

    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};

    (window as any).__restoreConsole = () => {
      console.log = originalLog;
      console.warn = originalWarn;
      console.error = originalError;
      console.info = originalInfo;
      console.debug = originalDebug;
    };
  }
};

// Initialize debug logger immediately
setupDebugLogger();

library.add(fas, far, fal);

const pinia = createPinia();

import Vapor from 'laravel-vapor';
window.Vapor = Vapor;
pinia.use(({ store }) => {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => {
    store.$patch(cloneDeep(initialState));
  };
});

createInertiaApp({
  title: (title) => `${title}`,
  defaults: {
    prefetch: {
      cacheFor: ['5m', '30m'],
    },
  },
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
    ),
  setup({ el, App, props, plugin }) {
    createSSRApp({ render: () => h(App, props) })
      .use(plugin)
      .use(pinia)
      .use(PerfectScrollbarPlugin)
      .use(VueAwesomePaginate)
      .use(VueTippy, TooltipConfig)
      .use(ZiggyVue)
      .mixin({ methods: { asset: window.Vapor.asset } })
      .component('FontAwesomeIcon', FontAwesomeIcon)
      .mount(el);
  },
  progress: {
    color: '#0077C1',
  },
});
